import AbstractBanner from './AbstractBanner/AbstractBanner';
import I18n from 'I18n';
import { getScopes } from '../../selectors';
import { useSelector } from 'react-redux';
import { memo, useMemo } from 'react';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACCOUNT_TYPES_DOC = 'https://developers.hubspot.com/hubspot-account-types';
const SCOPE_CRM_ACCESS = 'full-crm-access';
const SCOPE_MARKETING_PRODUCT_ACCESS = 'marketing-product-access';
const SCOPE_DEVELOPERS_PORTAL_ACCESS = 'developers-portal-access';
const isDeveloperPortal = scopes => {
  if (!scopes.includes(SCOPE_DEVELOPERS_PORTAL_ACCESS)) {
    return false;
  }
  /**
   * If the user has these scopes, even if they have developer portal access,
   * it is considered a hybrid portal and the banner should not be shown
   */
  if (scopes.includes(SCOPE_MARKETING_PRODUCT_ACCESS) || scopes.includes(SCOPE_CRM_ACCESS)) {
    return false;
  }
  return true;
};
const DeveloperBanner = () => {
  const scopes = useSelector(getScopes);
  const isDevPortal = useMemo(() => isDeveloperPortal(scopes), [scopes]);
  return isDevPortal ? /*#__PURE__*/_jsx(AbstractBanner, {
    isCloseable: false,
    title: I18n.text('alerts.developer.title'),
    type: "info",
    "data-test-id": 'developer-banner',
    children: /*#__PURE__*/_jsxs(Text, {
      paddingInline: "200",
      children: [I18n.text('alerts.developer.description'), /*#__PURE__*/_jsx(Link, {
        target: "_blank",
        rel: "noopener noreferrer",
        href: ACCOUNT_TYPES_DOC,
        external: true,
        paddingInlineStart: "200",
        children: /*#__PURE__*/_jsx("b", {
          children: I18n.text('alerts.developer.linkText')
        })
      })]
    })
  }) : null;
};
export default /*#__PURE__*/memo(DeveloperBanner);